import { VoteByEventId, VoteType } from "api/vote";
import Pending from "containers/Pending";
import useBoundStore from "store";

interface TimelineEventPendingVotesProps {
  onBack?: () => void;
}

export default function TimelineEventPendingVotes(props: TimelineEventPendingVotesProps): JSX.Element | null {
  const { onBack } = props;
  const selected = useBoundStore((state) => state.selected);

  const pendingVotes: VoteByEventId[] = [];
  const participantsUids: number[] = [];
  if (selected.timelineEvent?.votes && selected.timelineEvent.users) {
    const { votes } = selected.timelineEvent;
    votes.forEach((vote) => {
      if (vote.event_id === selected.timelineEvent?.id) {
        if (vote.type === VoteType.PENDING) {
          pendingVotes.push(vote);
        } else {
          participantsUids.push(vote.uid);
        }
      }
    });
    const users = selected.timelineEvent?.users.filter((user) => !participantsUids.includes(user.uid ?? Infinity));

    return <Pending users={users} votes={pendingVotes} onBack={onBack} />;
  }

  return null;
}
